import type { Term } from '../../types';
import styles from './PrivacyPolicy.module.scss';

export type PrivacyPolicyProps = {
  policy: Term;
};

function PrivacyPolicy({ policy }: PrivacyPolicyProps) {
  // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
  return <section className={styles.componentStyle} dangerouslySetInnerHTML={{ __html: policy.term }} />;
}

export default PrivacyPolicy;
